import qs from 'qs';

/**
 * クエリパラメーターをenumに変換する
 * @param queryParams クエリパラメーター
 */

export const parse = (queryParams: string) => {
  const query = String(queryParams);
  const res = qs.parse(query.substr(1));

  return res;
};
